import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';


export default class ImageComponent extends Component {
    render() {
        let {image, options}=this.props;

        return image && image.url
        && <figure className="card-image">
            <img src={image.url} style={options} alt={image.alt} desc={image.desc} />
        </figure>


    }
}


